import { FormForType, formFor, Validators } from "fw-model";
import { CommonAppIntegration, CommonAppIntegrationArgs } from "models/common-app-integration";

const { inRange, isInteger, wrap } = Validators;

export type FormForCommonAppIntegrationArgs = FormForType<CommonAppIntegrationArgs>;

export class CreateCommonAppIntegrationAction {
    public created: CommonAppIntegration = null;
    constructor(
        public organizationId: string,
        public form: FormForCommonAppIntegrationArgs
    ) {}
}

export class UpdateCommonAppIntegrationAction {
    public updated: CommonAppIntegration = null;
    constructor(
        public commonAppIntegrationId: string,
        public form: FormForCommonAppIntegrationArgs
    ) {}
}

export const createCommonAppIntegrationFormCreator = formFor(CommonAppIntegrationArgs, (s) => {
    s.requiredField((f) => f.CommonAppYear, "Common App Cycle", wrap(isInteger, inRange(2021, 2050)));
    s.requiredField((f) => f.SdsUsername, "Username");
    s.requiredField((f) => f.SdsPassword, "Password");
    s.requiredField((f) => f.DataCatalog, "Data Catalog");
    s.requiredField((f) => f.Enabled, "Active");
});

export const updateCommonAppIntegrationFormCreator = formFor(CommonAppIntegrationArgs, (s) => {
    s.requiredField((f) => f.CommonAppYear, "Common App Cycle", wrap(isInteger, inRange(2021, 2050)));
    s.requiredField((f) => f.SdsUsername, "Username");
    s.field((f) => f.SdsPassword, "Password");
    s.field((f) => f.DataCatalog, "Data Catalog");
    s.requiredField((f) => f.Enabled, "Active");
});
